import React from 'react';
import Icon from '../../../components/AppIcon';

const OnboardingDataDisplay = ({ candidateData }) => {
  const {
    experience,
    language,
    location,
    workMode,
    seniority,
    industry,
    companyContext,
    managementScope,
    businessResponsibility,
    budgetManagement,
    industrySpecific
  } = candidateData;

  const sections = [
    {
      title: 'Professional Overview',
      icon: 'Briefcase',
      items: [
        { label: 'Experience', value: experience },
        { label: 'Seniority Level', value: seniority },
        { label: 'Industry', value: industry }
      ]
    },
    {
      title: 'Work Preferences',
      icon: 'MapPin',
      items: [
        { label: 'Language', value: language },
        { label: 'Location', value: location },
        { label: 'Work Mode', value: workMode }
      ]
    },
    {
      title: 'Leadership & Scope',
      icon: 'Users',
      items: [
        { label: 'Company Context', value: companyContext },
        { label: 'Management Scope', value: managementScope },
        { label: 'Business Responsibility', value: businessResponsibility },
        { label: 'Budget Management', value: budgetManagement }
      ]
    }
  ];

  if (industrySpecific && Object.keys(industrySpecific)?.length > 0) {
    sections?.push({
      title: `${industry} Expertise`,
      icon: 'Award',
      items: Object.entries(industrySpecific)?.map(([key, value]) => ({
        label: key?.replace(/([A-Z])/g, ' $1')?.trim()?.replace(/^./, str => str?.toUpperCase()),
        value: Array.isArray(value) ? value?.join(', ') : value
      }))
    });
  }

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#0025cc] to-[#0025cc]">
          <Icon name="FileText" size={20} color="#FFFFFF" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-[#111827]">Your Profile Data</h2>
          <p className="text-sm md:text-base text-[#6B7280]">Information from your onboarding</p>
        </div>
      </div>
      {sections?.map((section, index) => (
        <div key={index} className="bg-white rounded-2xl p-4 md:p-6 border border-[#E5E7EB]">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center bg-[#F6F7FB]">
              <Icon name={section?.icon} size={18} color="#5B2DFF" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-[#111827]">{section?.title}</h3>
          </div>

          <div className="space-y-3 md:space-y-4">
            {section?.items?.map((item, itemIndex) => (
              <div key={itemIndex} className="flex flex-col gap-1">
                <span className="text-xs md:text-sm font-medium text-[#6B7280]">{item?.label}</span>
                <span className="text-sm md:text-base text-[#111827]">{item?.value || 'Not specified'}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OnboardingDataDisplay;